module.exports = __webpack_public_path__ + "static/media/icon_d.7c353693.png";